import Main from "./components/Main";
import Navbar from "./components/Navbar";

function App() {
  return (
    <div className="">
      <Navbar />
      <Main />
    </div>
  );
}

export default App;
